import Vue from 'vue'
import { MutationTree } from 'vuex'
import { IAppState, IAppInfo } from './types'

const mutations: MutationTree<IAppState> = {
  SET_APP_INFO (state, payload: IAppInfo) {
    const oldData = state.appInfo || {}
    const newData = { ...oldData, ...payload }
    newData.admins = payload.admins
    Vue.set(state, 'appInfo', newData)
  },

  UPDATE_APP_INFO (state, payload: any) {
    const oldData = state.appInfo || {}
    const newData = { ...oldData, ...payload }
    Vue.set(state, 'appInfo', newData)
  },

  SET_APP_AUTH_CONFIGS (state, payload: any) {
    const oldData = state.appInfo || {}
    const newData = { ...oldData, ...payload }
    Vue.set(state, 'appInfo', newData)
  },

  SET_COMPANY_LIST (state, payload: any) {
    const oldData = state.appInfo || {}
    const newData = { ...oldData, ...payload }
    Vue.set(state, 'appInfo', newData)
  },

  SET_SYNC_INFO (state, payload: any) {
    const oldData = state.appInfo || {}
    const newData = { ...oldData, ...payload }
    Vue.set(state, 'appInfo', newData)
  },

  SET_AUTH_TAB_STATUS (state, payload: any) {
    const oldData = state.appInfo || {}
    const newData = { ...oldData, ...{ authTabStatus: payload } }
    Vue.set(state, 'appInfo', newData)
  },

  SET_MSG_CALLBACK_TAB_STATUS (state, payload: any) {
    const oldData = state.appInfo || {}
    const newData = { ...oldData, ...{ msgCallbackTabStatus: payload } }
    Vue.set(state, 'appInfo', newData)
  },

  SET_DOC_EDIT_CALLBACK_TAB_STATUS (state, payload: any) {
    const oldData = state.appInfo || {}
    const newData = { ...oldData, ...{ docEditCbTabStatus: payload } }
    Vue.set(state, 'appInfo', newData)
  },

  SET_DOC_PREVIEW_CALLBACK_TAB_STATUS (state, payload: any) {
    const oldData = state.appInfo || {}
    const newData = { ...oldData, ...{ docPreviewCbTabStatus: payload } }
    Vue.set(state, 'appInfo', newData)
  },

  SET_DOC_FORMAT_CALLBACK_TAB_STATUS (state, payload: any) {
    const oldData = state.appInfo || {}
    const newData = { ...oldData, ...{ docFormatCbTabStatus: payload } }
    Vue.set(state, 'appInfo', newData)
  },

  SET_SYNC_TAB_STATUS (state, payload: any) {
    const oldData = state.appInfo || {}
    const newData = { ...oldData, ...{ syncTabStatus: payload } }
    Vue.set(state, 'appInfo', newData)
  },

  SET_CALLBACK_TAB_STATUS (state, payload: any) {
    const oldData = state.appInfo || {}
    const newData = { ...oldData, ...{ callbackTabStatus: payload } }
    Vue.set(state, 'appInfo', newData)
  },

  SET_SPACE_CONFIG_TAB_STATUS  (state, payload: any) {
    const oldData = state.appInfo || {}
    const newData = { ...oldData, ...{ spaceConfigTabStatus: payload } }
    Vue.set(state, 'appInfo', newData)
  },

  SET_APPLY_FEATURE_LIST (state, payload: any) {
    const oldData = state.appInfo || {}
    const newData = { ...oldData, ...payload }
    Vue.set(state, 'appInfo', newData)
  },

  SET_COMPANY_ID (state, payload: any) {
    const oldData = state.appInfo || {}
    const newData = { ...oldData, ...payload }
    Vue.set(state, 'appInfo', newData)
  }
}

export default mutations
